// Copyright (c) 2017 Deere & Company

import CreateLayoutModal from './create-layout-modal';
import {connect} from 'react-redux';
import {sharedActionCreators} from '../../../action-creators';

const getStateToBindToContainerProps = state => ({
    ...state.reportVariant.createLayoutModal,
    columnApi: state.columnApi,
    gridApi: state.gridApi
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    ...ownProps
});

export default connect(getStateToBindToContainerProps, sharedActionCreators, mapBoundActionCreatorsToActionsProp)(CreateLayoutModal);



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-variant-modals/create-layout-modal/index.js